import { OrderItem, SortableField } from '../types';

export const sortByFieldDesc = (list: OrderItem[], field: SortableField): OrderItem[] => {
    return [...list].sort((a, b) => {
        const av = a[field] as unknown as number;
        const bv = b[field] as unknown as number;
        return av - bv;
    }).reverse();
};
